import { render, staticRenderFns } from "./EventReportSchoolWise.vue?vue&type=template&id=6acb7f67&scoped=true"
import script from "./EventReportSchoolWise.vue?vue&type=script&lang=js"
export * from "./EventReportSchoolWise.vue?vue&type=script&lang=js"
import style0 from "./EventReportSchoolWise.vue?vue&type=style&index=0&id=6acb7f67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acb7f67",
  null
  
)

export default component.exports